import React, { memo } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { formatInTimeZone } from 'date-fns-tz';
import officialscoresheetStyles from '../../officialscoresheet.module.css';
import { LineupVerificationFormTable } from '../shared/tables';
import { Clock } from '../shared/clock';

const {
  header,
  row,
  virtiusTitle,
  sessionInfo,
  sessionInfoLabel,
  sessionInfoValue,
  body,
  footer,
  subFooter,
  timestamp,
  lineupForm,
  signature,
  signatureLabel,
  signatureField,
  yellowCard,
} = officialscoresheetStyles;

function LineupVerificationHeader({
  team,
  sessionName,
  date,
  timezone,
  location,
  combineKey,
  combineSession,
}) {
  return (
    <section className={header}>
      <h1>
        <span className={virtiusTitle}>
          <span>V</span>irtius&nbsp;
        </span>
        <span style={{ fontWeight: '700' }}>Competition Form</span>
      </h1>
      <h2>LINEUP VERIFICATION ({team?.displayName})</h2>
      <section>
        <Row className={row}>
          <Col className={sessionInfo}>
            <div className={sessionInfoLabel}>
              Session{combineKey ? '(s)' : null}:&nbsp;
            </div>
            <div className={sessionInfoValue}>
              {sessionName}
              {combineKey ? ` + ${combineSession?.session?.name}` : null}
            </div>
          </Col>
        </Row>
        <Row className={row}>
          <Col className={sessionInfo}>
            <div className={sessionInfoLabel}>Date: </div>
            <div className={sessionInfoValue}>{`${formatInTimeZone(
              new Date(date),
              timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
              "M'/'dd'/'yyyy"
            )}`}</div>
          </Col>
        </Row>
        <Row className={row}>
          <Col className={sessionInfo}>
            <div className={sessionInfoLabel}>Location: </div>
            <div className={sessionInfoValue}>{location}</div>
          </Col>
        </Row>
      </section>
    </section>
  );
}

function LineupVerificationSign() {
  return (
    <section className={footer}>
      <section className={subFooter}>
        <Row className={row}>
          <Col className={signature} xs={2} />
          <Col
            className={signature}
            xs={2}
            style={{ flexDirection: 'row-reverse' }}
          >
            <div
              className={signatureLabel}
              style={{ textWrap: 'nowrap', flexDirection: 'row-reverse' }}
            >{`Changed: `}</div>
          </Col>
          <Col className={yellowCard} xs={1}>
            <Form.Check
              type="checkbox"
              label="&nbsp;&nbsp;Yes"
              id="lineupChangedYes"
              // checked={false}
            />
          </Col>
          <Col className={yellowCard} xs={1}>
            <Form.Check
              type="checkbox"
              label="&nbsp;&nbsp;No"
              id="lineupChangedNo"
              //checked={false}
            />
          </Col>
          <Col className={signature} xs={4}>
            <div
              className={signatureLabel}
              style={{ whiteSpace: 'nowrap' }}
            >{`Coach Initials: `}</div>
            <div className={signatureField}></div>
          </Col>
          <Col className={signature} xs={2} />
        </Row>
      </section>
    </section>
  );
}

function LineupVerificationBody({ team, apparatusArray }) {
  const numApparatus = apparatusArray.length;
  return (
    <main className={body}>
      <Row className={row}>
        <Col>
          <LineupVerificationFormTable
            team={team}
            apparatus={apparatusArray.slice(0, numApparatus / 2)}
          />
        </Col>
      </Row>
      <Row className={row}>
        <Col>
          <LineupVerificationFormTable
            team={team}
            apparatus={apparatusArray.slice(numApparatus / 2, numApparatus)}
          />
        </Col>
      </Row>
      <Row className={row}>
        <Col>
          <LineupVerificationSign />
        </Col>
      </Row>
    </main>
  );
}

function BasicScoresheetFooter({
  page,
  timezone,
  singleSheetOnly,
  sheetOptionsLength,
}) {
  const copyrightTimePageFooter = (page) => {
    return (
      <section className={subFooter}>
        <Row>
          <Col className={timestamp}>
            <span>
              © {new Date().getFullYear()} Virtius&nbsp;&nbsp;»&nbsp;&nbsp;
            </span>
            <Clock timezone={timezone} />
            <span>
              &nbsp;&nbsp;»&nbsp;&nbsp;Page {singleSheetOnly ? 1 : page} of{' '}
              {singleSheetOnly ? 1 : sheetOptionsLength}
            </span>
          </Col>
        </Row>
      </section>
    );
  };

  return <section className={footer}>{copyrightTimePageFooter(page)}</section>;
}

export const LineupVerificationScoreSheet = memo(_LineupVerificationScoreSheet);

function _LineupVerificationScoreSheet({
  page,
  sessionName,
  date,
  timezone,
  location,
  combineKey,
  combineSession,
  teams,
  apparatusArray,
  singleSheetOnly,
  sheetOptionsLength,
  options,
}) {
  const teamIndex = parseInt(options);
  const team = teams[teamIndex];

  return (
    <div className={lineupForm}>
      <LineupVerificationHeader
        team={team}
        sessionName={sessionName}
        date={date}
        timezone={timezone}
        location={location}
        combineKey={combineKey}
        combineSession={combineSession}
      />
      <LineupVerificationBody team={team} apparatusArray={apparatusArray} />
      <BasicScoresheetFooter
        page={page}
        timezone={timezone}
        singleSheetOnly={singleSheetOnly}
        sheetOptionsLength={sheetOptionsLength}
      />
    </div>
  );
}
